/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/views/web/product/conponents/ProductFormDeatil/ProductDetailMmuHead.tsx
 * @Description:
 */
import { useContext, useState, useMemo, useEffect, useRef } from 'react';
import { debounce } from 'lodash';
import { dateFormat } from 'libs/utils';
import { PriceContext } from 'libs/contexts';
// import { useRouter } from 'next/router';
import TradeMode from './TradeMode';
import NetPriceType from '../../../../../comps/NetPriceType';
import AgreementModal from '@/biz-components/web/AgreementModal';
import ProductDetailPriceDescModal from '../ProductDetailPriceDescModal';
import { NetPriceSourceEnum, AgreementType, AgreementPriceMissingReason } from 'libs/enums';
import numeral from 'numeral';
import { cls } from 'reactutils';
import { Select, Button } from 'antd';
import { apiUpdateLangeNetPrice } from 'api/mall';
import { saveProductSkuInfo } from 'api/product';
import { useNetPriceTypeContext, useProductDetailContext } from 'views/web/product/context';
import { downloadFile } from 'libs/fetch';
import useDetailPriceAndAgreement from '../../Detail/useDetailPriceAndAgreement';
const { Option } = Select;
const ProductDetailMmuHead = ({
  skuDetail,
  shopId,
  selectTradeAgreement,
  netPriceChange,
  agreementChange,
  tradeModeChange,
}) => {
  // const router = useRouter();
  // const supplierSkuSysNo = router?.query?.id || '';

  const currentTradeAgreementRef = useRef(selectTradeAgreement?.sysNo);
  const priceData = useContext(PriceContext);
  const { showPrice, tip } = priceData;
  const [updatePriceLoading, setUpdatePriceLoading] = useState(false);
  const [agreementVisible, setAgreementVisible] = useState(false);
  const [visiblePriceModal, setVisiblePriceModal] = useState(false);
  const [agreementModalSysNo, setAgreementModalSysNo] = useState('');
  const { selectNetPriceType } = useNetPriceTypeContext();
  const { getProductDetail } = useProductDetailContext();
  const {
    differentTypesAgreement,
    isThePriceDisplayed,
    externalPurchaser,
    externalPurchaserAudit,
    skuForPriceCalculate,
  } = useDetailPriceAndAgreement(skuDetail, updatePriceLoading);

  const indexCodeSet = useMemo(() => {
    return skuForPriceCalculate?.agreementPriceForm?.netPriceSourceInformation?.indexCodeSet || [];
  }, [skuForPriceCalculate]);

  // 价格变化时提交浏览记录
  useEffect(() => {
    const { salesPrice, unitName, name, thirdName, mainImage, sysNo } = skuDetail;
    if (!sysNo) {
      return;
    }
    const saveHistory = async () => {
      await saveProductSkuInfo({
        supplierSkuSysNo: sysNo,
        productImgUrl: mainImage,
        shopMainPage: shopId,
        productName: `${name}${thirdName || ''}`,
        productPrice: showPrice
          ? isThePriceDisplayed.display
            ? `${salesPrice}元/${unitName}`
            : isThePriceDisplayed.reason
          : tip,
      });
    };
    saveHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skuDetail.salesPrice]);

  const handleTradeAgreementDownload = debounce(
    () => {
      if (currentTradeAgreementRef.current) {
        downloadFile(
          `/api/mall/v1/mallSku/exportAgreementSkuList/${currentTradeAgreementRef.current}`,
        );
      }
    },
    1000,
    { leading: true, trailing: false },
  );

  const handleUpdatePrice = async () => {
    if (updatePriceLoading) return;
    setUpdatePriceLoading(true);
    try {
      await apiUpdateLangeNetPrice({
        json: indexCodeSet,
      });
      getProductDetail();
    } catch (error) {}
    setUpdatePriceLoading(false);
  };
  const priceLabelFromAgreement =
    !differentTypesAgreement.origin.length ||
    selectTradeAgreement.tradeAgreementScope === AgreementType.beCurrent
      ? '单价'
      : '协议价';
  const renderTaxPrice = skuDetail?.excludeTaxPrice
    ? numeral(skuDetail.excludeTaxPrice).format('0.00[000000]')
    : '--.--';
  const netPriceSourceInformation =
    skuForPriceCalculate?.agreementPriceForm?.netPriceSourceInformation;
  const basePriceCanNotSale =
    skuDetail.salesPrice === null &&
    skuDetail.agreementCanSale &&
    skuForPriceCalculate.agreementPriceMissingReason ===
      AgreementPriceMissingReason.TRADE_AGREEMENT_PRICE_MISSING;

  const visibleAgreementModal = useMemo(() => {
    // const isSupplier = userInfo?.currentUserType === CurrentUserTypeSource.supplier;
    // 未认证外部采购商或供应商
    // if ((externalPurchaser && !externalPurchaserAudit) || isSupplier) {
    if (externalPurchaser && !externalPurchaserAudit) {
      return false;
    }
    return Boolean(differentTypesAgreement.origin.length);
  }, [differentTypesAgreement, externalPurchaser, externalPurchaserAudit]);

  return (
    <div className="pd-hd">
      <div className="pd-tit">
        <h3>
          {skuDetail?.titleProductTag?.map((item, index) => (
            <div key={index} className="product-intro-r-title-tag">
              {item.tagName}
            </div>
          ))}
          {skuDetail?.skuType === 1 && (
            <span className="product-intro-r-title-lease-tag">租赁</span>
          )}
          <span>{skuDetail.name}</span>
          <span>{skuDetail.thirdName}</span>
        </h3>
      </div>
      <div className="pd-desc">{skuDetail.promotionTitle}</div>
      <div className="pd-price">
        {/* <!-- 点击按钮更新网价 --> */}
        {skuForPriceCalculate.netPriceSource === NetPriceSourceEnum.LANGE &&
          !!indexCodeSet.length && (
            <div
              className={cls('btn btn-primary update-price-btn', updatePriceLoading && 'disabled')}
              onClick={handleUpdatePrice}
            >
              更新网价
            </div>
          )}
        {/* <!-- 商品价格label --> */}
        <div className="pd-one clearfix">
          <div className="pd-l">{priceLabelFromAgreement}</div>

          {/* <!-- 商品价格是否有权限展示 --> */}

          {/* <!-- 有权限展示 --> */}
          {showPrice ? (
            isThePriceDisplayed.display ? (
              <div className="pd-r J_price-row-wrap">
                <div className="pd-r pd-one-info">
                  <span className="pd-one-rmb">¥</span>
                  <span className="pd-one-price J_one-price">
                    {numeral(skuDetail.salesPrice).format('0.00[000000]')}
                  </span>
                  <span className="pd-one-separator">/</span>
                  <span className="pd-one-unit">{skuDetail.unitName}</span>
                </div>
                <div className="pd-l tax-label">不含税价</div>
                <div className="pd-r tax-value">
                  ¥<span className="J_tax-value"> {renderTaxPrice} </span>
                  <span className="pd-tax-free-num">/</span>
                  <span className="pd-tax-free-num">{skuDetail.unitName}</span>
                </div>
                {skuDetail.taxRate != null && (
                  <div className="pd-l tax-label" style={{ whiteSpace: 'nowrap' }}>
                    税率：<span className="J_tax-rate"> {skuDetail.taxRate} </span>%
                  </div>
                )}
              </div>
            ) : (
              <div className="pd-r" style={{ marginBottom: '10px' }}>
                <span className="pd-one-rmb"> {isThePriceDisplayed.reason} </span>
              </div>
            )
          ) : (
            <div className="pd-r">
              <span className="pd-one-rmb">¥{tip}</span>
            </div>
          )}
        </div>

        {visibleAgreementModal &&
          (selectTradeAgreement.sysNo ? (
            <div className="product-detail-price-desc">
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setAgreementModalSysNo(selectTradeAgreement.sysNo);
                  setAgreementVisible(true);
                }}
              >
                {selectTradeAgreement.tradeAgreementScope === AgreementType.internal
                  ? '此价格为协议价，点此可查看交易规则'
                  : '点此查看交易规则'}
              </span>
            </div>
          ) : skuDetail.priceDesc ? (
            <div className="product-detail-price-desc" style={{ marginBottom: 0 }}>
              {skuDetail.priceDesc}
            </div>
          ) : (
            ''
          ))}
        {skuForPriceCalculate.netPriceSource && !selectNetPriceType && (
          <>
            {skuForPriceCalculate.netPriceSource === NetPriceSourceEnum.INFO && (
              <div className="pd-one clearfix pd-one-price-source-info">
                <div className="pd-l">信息价</div>
                <div className="pd-r">
                  {!netPriceSourceInformation || netPriceSourceInformation.price === null ? (
                    '暂无信息价'
                  ) : (
                    <>
                      <span className="price-form-txt-item">
                        价格:
                        {netPriceSourceInformation.price}
                        {netPriceSourceInformation.suffix}
                      </span>
                      <span className="price-form-txt-item">
                        来源: {netPriceSourceInformation.netPriceSourceString}
                      </span>
                      <i
                        className="price-form-txt-item icon iconfont icon-tishishuoming"
                        onClick={() => {
                          setVisiblePriceModal(true);
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            )}
            {(skuForPriceCalculate.netPriceSource === NetPriceSourceEnum.LANGE ||
              skuForPriceCalculate.netPriceSource === NetPriceSourceEnum.WDGTW ||
              skuForPriceCalculate.netPriceSource === NetPriceSourceEnum.SHYSJSW) &&
              !basePriceCanNotSale && (
                <div className="pd-one clearfix pd-one-price-source-info">
                  <div className="pd-l">网价信息</div>
                  <div className="pd-r">
                    {!netPriceSourceInformation || netPriceSourceInformation.price === null ? (
                      '暂无网价'
                    ) : updatePriceLoading ? (
                      ' 正在获取… '
                    ) : (
                      <>
                        <span className="price-form-txt-item">
                          日期: {dateFormat(netPriceSourceInformation.date)}
                        </span>
                        <span className="price-form-txt-item">
                          {netPriceSourceInformation.prefix}:{netPriceSourceInformation.price}
                          {netPriceSourceInformation.suffix}
                        </span>
                        <span className="price-form-txt-item">
                          来源: {netPriceSourceInformation.netPriceSourceString}
                        </span>
                        {netPriceSourceInformation.publishDate && (
                          <span className="price-form-txt-item">
                            发布时间:
                            {dateFormat(netPriceSourceInformation.publishDate, 'YYYY-MM-DD HH:mm')}
                          </span>
                        )}
                        <i
                          className="price-form-txt-item icon iconfont icon-tishishuoming"
                          onClick={() => {
                            setVisiblePriceModal(true);
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>
              )}
            {skuForPriceCalculate.netPriceSource === NetPriceSourceEnum.BASE && (
              <div className="pd-one clearfix pd-one-price-source-info">
                <div className="pd-l">基础价</div>
                <div className="pd-r">
                  {!netPriceSourceInformation || netPriceSourceInformation.price === null ? (
                    '暂无基础价'
                  ) : (
                    <>
                      <span className="price-form-txt-item">
                        {netPriceSourceInformation.prefix}:{netPriceSourceInformation.price}
                        {netPriceSourceInformation.suffix}
                      </span>
                      <span className="price-form-txt-item">
                        来源: {netPriceSourceInformation.netPriceSourceString}
                      </span>
                      <i
                        className="price-form-txt-item icon iconfont icon-tishishuoming"
                        onClick={() => {
                          setVisiblePriceModal(true);
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            )}
          </>
        )}

        {!!differentTypesAgreement?.alternative?.length && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className="pd-l account-label">规则</div>
            <div className="pd-r" style={{ display: 'flex', alignItems: 'center' }}>
              <Select
                placeholder="请选择规则"
                value={selectTradeAgreement.sysNo}
                onChange={(val) => {
                  agreementChange(val);
                  // 保存当前选中的规则
                  currentTradeAgreementRef.current = val;
                }}
              >
                {differentTypesAgreement.alternative.map((item, index) => (
                  <Option
                    key={index}
                    className="select-agreement-option"
                    value={item.sysNo}
                    title={item.newFlag === 3 ? `${item.contractName}--${item.name}` : item.name}
                  >
                    <div className="select-agreement">
                      <span className="agreement-select-list-item-txt">
                        {item.newFlag === 1 && <span className="agreement-tag">定价规则</span>}
                        {item.newFlag === 3 && (
                          <>
                            <span className="agreement-tag">商城计价规则</span>
                            <span>{item.contractName}--</span>
                          </>
                        )}
                        {item.newFlag !== 1 && item.newFlag !== 3 && (
                          <span className="agreement-tag">交易规则</span>
                        )}
                        {item.name}
                      </span>
                      <span
                        className="agreement-select-list-item-btn"
                        onClick={(event) => {
                          setAgreementModalSysNo(item.sysNo);
                          setAgreementVisible(true);
                          event.stopPropagation();
                        }}
                      >
                        查看规则
                      </span>
                    </div>
                  </Option>
                ))}
              </Select>
              <Button type="link" onClick={handleTradeAgreementDownload}>
                查看绑定商品清单
              </Button>
            </div>
          </div>
        )}

        {/* 网价*/}
        {selectNetPriceType && netPriceSourceInformation && (
          <>
            <NetPriceType selectNetPriceType={selectNetPriceType} onSelect={netPriceChange} />
            <div className="pd-r" style={{ paddingLeft: '110px' }}>
              <span className="price-form-txt-item" style={{ marginRight: '20px' }}>
                日期: {dateFormat(netPriceSourceInformation.date)}
              </span>
              <span className="price-form-txt-item" style={{ marginRight: '20px' }}>
                {netPriceSourceInformation.prefix}:{netPriceSourceInformation.price}
                {netPriceSourceInformation.suffix}
              </span>
              <span className="price-form-txt-item" style={{ marginRight: '20px' }}>
                来源: {netPriceSourceInformation.netPriceSourceString}
              </span>
            </div>
          </>
        )}

        {!!selectTradeAgreement?.discountByMethodList?.length && (
          <TradeMode selectTradeAgreement={selectTradeAgreement} onSelect={tradeModeChange} />
        )}
      </div>
      <div className="pd-row row">
        <div className="col col-12 clearfix">
          <div className="pd-l">商品编号</div>
          <div className="pd-r">{skuDetail.sysNo}</div>
        </div>
        <div className="col sm col-12 clearfix">
          <div className="pd-l">品牌</div>
          <div className="pd-r">{skuDetail.brandName}</div>
        </div>
      </div>
      <div className="pd-row row">
        <div className="col col-12 clearfix">
          <div className="pd-l">规格描述</div>
          <div className="pd-r">{skuDetail.formulaModel}</div>
        </div>
        {skuDetail.sellCountString != null && (
          <div className="col sm col-12 clearfix">
            <div className="pd-l">销量</div>
            <div className="pd-r">{skuDetail.sellCountString}</div>
          </div>
        )}
      </div>
      {!!skuDetail.qualityStandard && (
        <div className="pd-row row">
          <div className="col clearfix">
            <div className="pd-l">质量标准</div>
            <div
              className="pd-r ellipsis"
              style={{ width: '630px' }}
              title={skuDetail.qualityStandard}
            >
              {skuDetail.qualityStandard}
            </div>
          </div>
        </div>
      )}
      {!!skuDetail.serviceProductTag?.length && (
        <div className="pd-row row">
          <div className="col clearfix">
            <div className="pd-l">服务</div>
            <div className="pd-r">
              <div className="product-intro-r-service-tag-wrap">
                {skuDetail.serviceProductTag.map((item, index) => (
                  <div className="product-intro-r-service-tag" key={index}>
                    {item.tagName}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      <AgreementModal
        visible={agreementVisible}
        sysNo={agreementModalSysNo}
        isFricing={!!skuDetail.newFlag}
        netPriceType={selectNetPriceType}
        onCancel={() => {
          setAgreementVisible(false);
        }}
      />
      <ProductDetailPriceDescModal
        visible={visiblePriceModal}
        skuForPriceCalculate={skuForPriceCalculate}
        title="报价因素"
        onClose={() => {
          setVisiblePriceModal(false);
        }}
      />
      <style jsx>{`
     .pd-hd {
        font-weight: 400;
        letter-spacing: .01em;
        padding-bottom: 20px;
        border-bottom: 1px solid #f1f1f1;
      }
      .pd-tit {
        color: #333;
        margin-bottom: 4px;
      }
     .pd-hd .pd-tit h3 {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 400;
        line-height: 25px;
      }
      .product-intro-r-title-tag {
        padding: 4px;
        background: #178fd5;
        border-radius: 1px;
        font-size: 12px;
        color: #ffffff;
        line-height: 1;
        display: inline-block;
        margin-right: 7px;
        z-index: 1;
      }
      .product-intro-r-title-lease-tag {
        padding: 4px;
        background: #ffdf25;
        border-radius: 1px;
        font-size: 12px;
        line-height: 1;
        margin-right: 7px;
        z-index: 1;
      }
     .pd-hd .pd-desc {
        margin-bottom: 4px;
        font-size: 14px;
        font-weight: 400;
        white-space: normal;
        word-break: break-word;
        color: #999;
      }
      .pd-price {
        background-color: #f6f6f6;
        padding-top: 11.5px;
        padding-bottom: 11.5px;
        margin-top: 10px;
        margin-bottom: 20px;
        position: relative;
      }
      .price-form-txt-item {
        margin-right: 6px;
      }
      .btn {
          display: inline-block;
          vertical-align: top;
          padding: 0 0.5em;
          text-align: center;
          font-size: 12px;
          cursor: pointer;
      }
      .btn-primary {
        color: #fff;
        background-color: var(--rv-primary-color);
      }
      .update-price-btn {
        position: absolute;
        right: 20px;
        top: 25px;
        width: 70px;
        height: 25px;
        line-height: 25px;
        cursor: pointer;
        z-index: 10;
        font-size: 12px;
        border-radius: 4px;
      }
      .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .product-detail .pd-hd .pd-one {
        overflow: hidden;
        position: relative;
      }
     .pd-l {
        width: 50px;
        margin-right: 40px;
        color: #999;
        margin-left: 20px;
        height: 28px;
        line-height: 28px;
      }
     .pd-l, .pd-r {
        display: inline-block;
        font-size: 12px;
      }
     .pd-row {
        font-size: 0;
        margin-top: 8px;
        display: flex;
      }
     .pd-row .col {
        position: relative;
        padding-left: 110px;
        font-size: 12px;
      }
     .pd-row .col.sm {
        padding-left: 80px;
      }
      .col .pd-l {
        width: 110px;
        position: absolute;
        top: 0;
        left: 0;
        padding-left: 20px;
        line-height: 17px;
        margin: 0;
        font-size: 12px;
      }
      .col-12 {
        width: 50%;
      }
     .pd-hd .pd-one-rmb {
        font-size: 14px;
        color: #fa5400;
        margin-right: 2px;
        vertical-align: baseline;
      }
      .pd-one-info {
        position: relative;
        bottom: -4px;
      }
      .pd-one-price, .pd-one-rmb, .pd-one-separator, .pd-one-unit {
        font-size: 14px;
        color: #f8551e;
        margin-right: 2px;
        vertical-align: baseline;
      }
      .pd-one-price {
        font-size: 28px;
      }
      .pd-one-unit {
        margin-right: 0;
      }
      .tax-label {
        margin-left: 25px;
        margin-right: 8px;
      }
      .pd-hd :global(.ant-select) {
        width: 520px;
        height: 28px;
        background: #ffffff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        color: #178fd5;
        cursor: pointer;
        border: 1px solid #f1f1f1;
      }
      .pd-hd :global(.pd-price .pd-r .ant-select-selector) {
        border: none;
        box-shadow: none !important;
        height: 26px;
        padding: 0 12px 0 18px;
      }
      .pd-hd :global(.ant-select-selection-search-input) {
        height: 26px !important;
      }
      .pd-hd :global(.ant-select-selection-item, .ant-select-selection-placeholder) {
        line-height: 26px !important;
      }
      .agreement-select-list-item-btn {
        cursor: pointer;
        display: none;
        flex: 0 0 51px;
        color: var(--rv-primary-color);
        font-weight: 400 !important;
      }
      :global(.ant-select-dropdown) {
        padding: 0;
      }
      :global(.ant-select-dropdown .select-agreement-option) {
        padding: 0;
        background-color: #fff !important;
        min-height: 28px;
      }
      :global(.ant-select-dropdown .select-agreement) {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 28px;
        padding-left: 19px;
        padding-right: 16px;
        cursor: pointer;
        font-size: 12px;
      }
      :global(.ant-select-dropdown .select-agreement:hover) {
        background-color: rgba(1, 141, 215, 0.1);
      }
      .pd-hd :global(.ant-select-dropdown .select-agreement:hover .agreement-select-list-item-txt) {
        color: var(--rv-primary-color);
      }
      .pd-hd :global(.agreement-select-list-item-txt) {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      :global(.ant-select-dropdown .select-agreement:hover .agreement-select-list-item-btn) {
        display: block;
      }
      .product-detail-price-desc {
        font-size: 12px;
        color: #fa6317;
        line-height: 1;
        margin: 4px 0 20px 0;
        padding-left: 114px;
      }
      .pd-one-price-source-info {
        margin-bottom: 15px;
      }
      .icon {
        font-size: 1em;
      }
      .price-form-txt-item.icon-tishishuoming {
        cursor: pointer;
      }
      .agreement-tag {
        padding: 3px 5px;
        border-radius: 5px;
        background-color: rgba(59, 109, 199, 1);
        color: #fff;
        margin-right: 5px;
      }
    `}</style>
    </div>
  );
};
export default ProductDetailMmuHead;
